export class PatientHealthEvent {
  idEventoSalud: string;
  idPaciente: string;
  fecha: string;
  eventoDeSalud: number;
  descripcion: string;
  nombreEvento?: string;

  constructor(patientHealthEvent: PatientHealthEvent) {
    this.idEventoSalud = patientHealthEvent.idEventoSalud || '';
    this.idPaciente = patientHealthEvent.idPaciente || '';
    this.fecha = patientHealthEvent.fecha || '';
    this.eventoDeSalud = patientHealthEvent.eventoDeSalud || 0;
    this.descripcion = patientHealthEvent.descripcion || '';
    this.nombreEvento = patientHealthEvent.nombreEvento || '';
  }

}
